<template>
	<div white-back full-height>

		<v-toolbar dark flat fixed nopadding>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title>Notification</v-toolbar-title>
        </v-toolbar>

	    <div class="hasToolbar">
            <v-card flat v-if="notificationData">
                <v-card-title class="title" style="line-height: 1.5 !important;padding: 16px 16px 0px;">
                    {{ notificationData.NotificationTitle }}
                </v-card-title>
                <v-card-text>
                    <div v-html="notificationData.NotificationMessage"></div>
                    <div class="pt-4 light-opacity-color font-small">{{ notificationData.CompletedOn | moment("DD-MMM-YYYY hh:mm a") }}</div>
                </v-card-text>
            </v-card>

            <div class="pa-4 center-align" v-if="!notificationData && !loading">
                <div>Something went wrong!</div>
                <v-btn class="mt-3" outline flat capitalize color="primary" @click="fn_getToken">Retry</v-btn>
            </div>
	    </div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				notificationData:null,
                loading:false
			}
		},
		methods:{

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_getToken: function(){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    return;
                }
                
                this.loading = true;
				this.showLoading("Please wait...");
				this.$root.fn_getAuthToken(token => {
                    if(token == 'error'){
                        this.hideLoading();
                    }
                    else{
                        this.fn_getNotification(token);
                    }
                });
            },

            fn_getNotification: function(token){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    this.loading = false;
                    return;
                }
                
                let self = this;
                let dataObj = {};
                dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
                dataObj.token = token;
                dataObj.notificationId = this.$route.params.notificationid;

                this.getServerData('GetNotification', dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.notificationData = JSON.parse(response);
                        self.loading = false;
                        self.hideLoading();
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.loading = false;
                        self.hideLoading();
                        if(typeof JSON.parse(error) == 'object'){
                            let response = JSON.parse(error);
                            self.showToast(response.Message);
                        }
                    }, 
                }
            )}

			
    },

    mounted: function(){
        window.js_globals.fn_onBackPress = this.fn_goBack;
        if(this.$route.params.notificationid){
            this.fn_getToken();
        }
        else{
            self.showToast("Something went wrong. Try again!.");
        }
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/notification/notification_detail.vue